import { render, staticRenderFns } from "./NoticeCenter.vue?vue&type=template&id=33d7d0db&scoped=true&"
import script from "./NoticeCenter.vue?vue&type=script&lang=js&"
export * from "./NoticeCenter.vue?vue&type=script&lang=js&"
import style0 from "./NoticeCenter.vue?vue&type=style&index=0&id=33d7d0db&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33d7d0db",
  null
  
)

component.options.__file = "NoticeCenter.vue"
export default component.exports